import React from "react";
import {
  getWeeksInYearRange,
  calculateWeekWidthsInRange,
  getDaysInYearRange,
  getMonthsInRange
} from "../../dashboard/utils/date";
import { Tooltip } from "@fluentui/react-components";
import { dateOnlyFormatted } from "../../../utils/systemSettings";

export const TimelineHeader = ({ viewType, subHeader = false, displayYearRange, dynamicWidths }) => {
  const setting = JSON.parse(localStorage.getItem("settings"));
  const formatDay = (date) => {
    return date.getDate().toString().padStart(2, "0");
  };

  const formatDate = (start, end) => {
    const startMonth = start.toLocaleString("en-US", { month: "short" });
    const endMonth = end.toLocaleString("en-US", { month: "short" });
    const startYear = start.getFullYear();
    const endYear = end.getFullYear();

    const formatShortYear = (year) => year.toString().slice(-2);

    if (startYear === endYear && startMonth === endMonth) {
      return `${formatDay(start)}-${formatDay(end)} ${endMonth}`;
    }

    if (startYear === endYear) {
      return `${formatDay(start)} ${startMonth} - ${formatDay(
        end
      )} ${endMonth}`;
    }

    return `${formatDay(start)} ${startMonth}, ${formatShortYear(
      startYear
    )} - ${formatDay(end)} ${endMonth}, ${formatShortYear(endYear)}`;
  };

  const getQuarterWidth = () => {
    return dynamicWidths?.useDynamic ? dynamicWidths.quarterWidth : 125.25;
  };

  const getYearWidth = () => {
    return dynamicWidths?.useDynamic ? dynamicWidths.yearWidth : 501;
  };

  if (viewType === "week") {
    const weeks = getWeeksInYearRange(displayYearRange.start, displayYearRange.end);
    return (
      <div className="flex h-full">
        {weeks.map((week, index) => {
          const startDay = week[0];
          const endDay = week[week.length - 1];

          return (
            <div
              key={index}
              className="w-[241px] text-sm border-r border-[#342c82] flex flex-col"
              style={{ height: "60px" }}
            >
              <div className="flex  gap-2 h-[36px] min-h-[36px] justify-center items-center px-2 border-b border-[#342c82]">
                <span className="whitespace-nowrap">Week {index + 1}</span>
                <span className="font-medium whitespace-nowrap">
                  {formatDate(startDay, endDay)}
                </span>
              </div>
              <div className="flex h-[30px] w-full">
                {week.map((day, i) => {
                  return (
                    <div
                      key={i}
                      className="relative text-xs flex-1 flex items-baseline justify-center"
                      style={{ 
                        minHeight: '100vh',
                        paddingTop: '2px'
                      }}
                    >
                      <div class="absolute right-0 top-0 h-full border-r border-black border-opacity-10 z-1"></div>
                      <Tooltip
                        content={`${dateOnlyFormatted(setting, day)}`}
                        relationship="label"
                      >
                        <span>
                          {day.toLocaleDateString("en-US", {
                            weekday: "narrow",
                          })}
                        </span>
                      </Tooltip>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  if (viewType === "month" && subHeader) {
    const weeks = getWeeksInYearRange(displayYearRange.start, displayYearRange.end);
    const weekWidths = calculateWeekWidthsInRange(displayYearRange.start, displayYearRange.end);
    
    return (
      <div className="flex h-full">
        {weeks.map((week, index) => {
          const weekWidth = weekWidths[index];
          return (
          <div 
            key={index} 
            className="relative text-xs flex items-center"
            style={{ 
              width: `${weekWidth}px`,
              minWidth: `${weekWidth}px`,
              flexShrink: 0,
              minHeight: '100vh',
              alignItems: 'baseline',
              justifyContent: 'center',
              paddingTop: '2px'
            }}
          >
            <div class="absolute right-0 top-0 h-full border-r border-black border-opacity-10 z-1"></div>
            <Tooltip
              content={`${dateOnlyFormatted(setting, week[0])} - ${dateOnlyFormatted(setting, week[week.length - 1])}`}
              relationship="label"
            >
              <span className="font-medium px-2 truncate">
                {formatDay(week[0])}-{formatDay(week[week.length - 1])}
              </span>
            </Tooltip>
            
          </div>
        );
        })}
      </div>
    );
  }

  if (viewType === "day") {
    const days = getDaysInYearRange(displayYearRange.start, displayYearRange.end);
    return (
      <div className="flex h-full">
        {days.map((day, i) => {
          return (
            <div
              key={i}
              className={`${day.toLocaleDateString() ===
                new Date().toLocaleDateString()
                ? "bg-[#EDECF8]"
                : ""
                } gap-1 w-[241px] text-sm flex justify-center items-baseline p-2`}
              style={{
                minHeight: '100vh',
                border:
                  day.toLocaleDateString() ===
                    new Date().toLocaleDateString()
                    ? "1px solid rgb(52, 44, 130)"
                    : null,
              }}
            >
              <div class="absolute right-0 top-0 h-full border-r border-[#342c82] border-opacity-50 z-1"></div>
              <span>
                {day.toLocaleDateString("en-US", {
                  month: "long",
                  day: "2-digit",
                })}
              </span>
            </div>
          );
        })}
      </div>
    );
  }
  if (viewType === "quarter") {
      const months = getMonthsInRange(displayYearRange.start, displayYearRange.end);
  
      const quarters = [];
      let currentYear = null;
      let quarterNumber = 1;
      let quarterMonths = [];
  
      for (let i = 0; i < months.length; i++) {
        const month = months[i];
  
        if (month.year !== currentYear) {
          if (quarterMonths.length > 0) {
            quarters.push({ year: currentYear, quarterNumber, months: quarterMonths });
          }
  
          currentYear = month.year;
          quarterNumber = 1;
          quarterMonths = [];
        }
  
        quarterMonths.push(month);
  
        if (quarterMonths.length === 3) {
          quarters.push({ year: currentYear, quarterNumber, months: quarterMonths });
          quarterNumber++;
          quarterMonths = [];
        }
      }
  
      if (quarterMonths.length > 0) {
        quarters.push({ year: currentYear, quarterNumber, months: quarterMonths });
      }
  
  
      return (
        <>
        <div className="flex h-full">
          {quarters.map((quarter, index) => {
            return (
              <div
                key={index}
                className="w-[501px] text-sm border-r border-[#342c82] flex flex-col"
                style={{ height: "60px" }}
              >
                <div className="flex  gap-2 h-[36px] min-h-[36px] justify-center items-center px-2 border-b border-[#342c82]">
                  <span className="whitespace-nowrap font-medium">{`Q${quarter.quarterNumber} - ${quarter.year}`}</span>
                </div>
                <div className="flex h-[30px] w-full">
                  {quarter.months.map((month, idx) => (
                    <div
                      key={idx}
                      className="relative font-medium text-sm flex-1 flex items-baseline justify-center w-[167px]"
                      style={{ minHeight: '100vh', paddingTop: '2px' }}
                    >
                      <div className="absolute right-0 top-0 h-full border-r border-black border-opacity-10 z-1"></div>
                        <span>{month.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        </>
      );
    }

  // Year view - show years with quarters as subdivisions
  if (viewType === "year") {
    const months = getMonthsInRange(displayYearRange.start, displayYearRange.end);
    
    // Group months into years with quarters
    const years = [];
    let currentYear = null;
    let yearQuarters = [];
    let quarterMonths = [];
    let quarterNumber = 1;
    
    for (let i = 0; i < months.length; i++) {
      const month = months[i];
      
      if (month.year !== currentYear) {
        // Save previous year if it exists
        if (currentYear !== null) {
          if (quarterMonths.length > 0) {
            yearQuarters.push({ quarterNumber, months: quarterMonths });
          }
          years.push({ year: currentYear, quarters: yearQuarters });
        }
        
        // Start new year
        currentYear = month.year;
        quarterNumber = 1;
        yearQuarters = [];
        quarterMonths = [];
      }
      
      quarterMonths.push(month);
      
      // Every 3 months, complete a quarter
      if (quarterMonths.length === 3) {
        yearQuarters.push({ quarterNumber, months: quarterMonths });
        quarterNumber++;
        quarterMonths = [];
      }
    }
    
    // Save the last year
    if (currentYear !== null) {
      if (quarterMonths.length > 0) {
        yearQuarters.push({ quarterNumber, months: quarterMonths });
      }
      years.push({ year: currentYear, quarters: yearQuarters });
    }

    return (
      <div className="flex h-full">
        {years.map((yearData, yearIndex) => {
          const yearWidth = getYearWidth();
          const quarterWidth = getQuarterWidth();
          
          return (
            <div
              key={yearIndex}
              className="text-sm border-r border-[#342c82] flex flex-col"
              style={{ width: `${yearWidth}px`, height: "60px" }}
            >
              <div className="flex gap-2 h-[36px] min-h-[36px] justify-center items-center px-2 border-b border-[#342c82]">
                <span className="whitespace-nowrap font-semibold text-base">{yearData.year}</span>
              </div>
              <div className="flex h-[30px] w-full">
                {[1, 2, 3, 4].map((qNum) => (
                  <div
                    key={qNum}
                    className="relative flex items-baseline justify-center z-1 border-[#342c82]"
                    style={{ 
                      width: `${quarterWidth}px`,
                      minHeight: '100vh', 
                      paddingTop: '2px',
                      borderRight: qNum < 4 ? '1px solid rgba(0, 0, 0, 0.1)' : 'none'
                    }}
                  >
                    <span className="font-medium text-sm">{`Q${qNum}`}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

    const months = getMonthsInRange(displayYearRange.start, displayYearRange.end);
  
  return (
    <div className="flex h-full">
      {months.map((month, index) => (
        <div
          key={`${month.year}-${index}`}
          className="w-[241px] font-medium text-sm justify-center border-r border-[#342c82] flex items-center p-2"
        >
          {month.name} {month.year}
        </div>
      ))}
    </div>
  );
}
